<template>
    <v-container fluid class="pa-0">
        <v-container class="">
            <v-row align="center" no-gutters class="text-start">
                <v-col>
                    <h3 class="text-h3" data-aos="fade-right">
                        {{data.title}}
                    </h3>
                    <v-btn 
                            :to="link" 
                            :key="link"
                            class="btn-primelinks" 
                            variant="text" 
                            color="primary">
                            <span class="text-underline">{{data.button}}</span>
                            <v-icon class="ms-3">mdi-arrow-right</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
        <ImgComparisonSlider @click="$router.push(link)" hover="hover" @slide="onSliding" class="w-100 slider-split-line slider-focus" id="comparison" :value="value">
        <!-- eslint-disable -->
        <div  slot="first" class="border-0" >

            <v-img
                    :lazy-src="data.left.image.sizes.thumbnail"
                    lazy
                    max-height="60vh"
                    min-height="30vh"
                    :src="data.left.image.sizes.full"
                    cover
                    gradient="to bottom, rgba(0,0,0,1), rgba(33,33,33,1), rgba(33,33,33,0.51), rgba(0,0,0,0.31), rgba(0,0,0,0.1), rgba(0,0,0,0.0), rgba(0,0,0,0.0), rgba(0,0,0,0.0), rgba(0,0,0,0.2),  rgba(18,18,18,0.51), rgba(18,18,18,1), rgba(0,0,0,1)"
                    :alt="data.left.image.title+' - '+data.left.image.description"
                    class="mx-auto"
            ></v-img>
        
        </div>

        <div  slot="second" class="border-0" >
            <v-img
                    :lazy-src="data.right.image.sizes.thumbnail"
                    lazy
                    max-height="60vh"
                    min-height="30vh"
                    :src="data.right.image.sizes.full"
                    cover
                    gradient="to bottom, rgba(0,0,0,1), rgba(33,33,33,1), rgba(33,33,33,0.51), rgba(0,0,0,0.31), rgba(0,0,0,0.1), rgba(0,0,0,0.0), rgba(0,0,0,0.0), rgba(0,0,0,0.0), rgba(0,0,0,0.2),  rgba(18,18,18,0.51), rgba(18,18,18,1), rgba(0,0,0,1)"
                    :alt="data.right.image.title+' - '+data.right.image.description"
                    class="mx-auto"
            ></v-img>
        </div>
        <!-- eslint-enable -->
    </ImgComparisonSlider>

    <v-container>
        <v-row align="center" no-gutters class="text-center">
            
            <v-col cols="12" class="mx-auto">
                <v-slider
                v-model="value"
                append-icon="mdi-chevron-right"
                prepend-icon="mdi-chevron-left"
                hide-details
                @click:append="addVale(+10)"
                @click:prepend="addVale(-10)"
                ></v-slider>
                <!-- <v-slider height="5" color="primary" v-model="value"></v-slider> -->
                <!-- <v-progress-linear height="5" color="primary" :v-model="value"></v-progress-linear> -->
            </v-col>
            <v-col cols="6" class="text-start">
                <v-btn :to="data.right.link" variant="text">
                    {{ data.right.label }}
                </v-btn>
            </v-col>
            <v-col cols="6" class="text-end">
                <v-btn :to="data.left.link" variant="text">
                    {{ data.left.label }}
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
    </v-container>
</template>
  
<script>
import { ImgComparisonSlider } from '@img-comparison-slider/vue';

export default {
    name: 'ComparisonComponent',
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    components: {
        ImgComparisonSlider,
    },
    data: () => ({
        value: 50,
        link: null
    }),
    mounted(){
        this.addVale(1)
    },
    methods:{
        onSliding(ev){
            this.value = ev.srcElement.exposure
            this.addVale(0)
        },
        addVale(n){
            this.value = this.value + n
            if(this.value < 0){
                this.value = 0
            }
            if(this.value > 100){
                this.value = 100
            }

            if(this.value >= 50){
                this.link = this.data.left.link
            }else{
                this.link = this.data.right.link
            }

        }
    }
};
</script>


<style>
  .slider-focus {
    /*
      The style below isn't necessary.
      It has been added for the sake of smoothness.
    */
    transition: box-shadow 0ms ease-in-out;
  }

  .slider-focus:focus {
    outline: none;
    box-shadow: 0px;
  }

  .slider-split-line {
    --divider-width: 4px;
    --divider-color: #ffffff;
    --default-handle-opacity: 0;
    --default-handle-shadow: 0px 0px 5px rgba(0, 0, 0, 1);
    --divider-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
  }
</style>